// extracted by mini-css-extract-plugin
export var label = "_93-1";
export var reminder = "_93-0";